"use strict";

var _classCallCheck = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/inherits");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prosemirror_state_1 = require("prosemirror-state");

var Extension_1 = __importDefault(require("../lib/Extension"));

var MaxLength =
/*#__PURE__*/
function (_Extension_1$default) {
  _inherits(MaxLength, _Extension_1$default);

  function MaxLength() {
    _classCallCheck(this, MaxLength);

    return _possibleConstructorReturn(this, _getPrototypeOf(MaxLength).apply(this, arguments));
  }

  _createClass(MaxLength, [{
    key: "name",
    get: function get() {
      return "maxlength";
    }
  }, {
    key: "plugins",
    get: function get() {
      var _this = this;

      return [new prosemirror_state_1.Plugin({
        filterTransaction: function filterTransaction(tr) {
          if (_this.options.maxLength) {
            var result = tr.doc && tr.doc.nodeSize > _this.options.maxLength;
            return !result;
          }

          return true;
        }
      })];
    }
  }]);

  return MaxLength;
}(Extension_1.default);

exports.default = MaxLength;